export const getTextDirection = lang => {
  return lang === 'ar' ? 'rtl' : 'ltr'
}
